import { useDisclosure } from '@chakra-ui/react';
import { Button, IconButton } from 'ui-components/dist/Button';
import { Modal, ModalBody, ModalHeader } from 'ui-components/dist/Modal';
import { ShareIcon } from 'ui-components/dist/ShareIcon';
import { useNoSSRBreakpointValue } from 'ui-components/dist/useNoSSRBreakpointValue';
import {
  Downloads,
  LinkViews,
  SwitchAudienceFilters,
} from '~/screens/MyAgency/components/ShareRosterModal';

export const ShareRosterModal: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const isBaseBreakpoint = useNoSSRBreakpointValue({ base: true, md: false });

  return (
    <>
      {isBaseBreakpoint ? (
        <IconButton
          variant="primary"
          aria-label="Share creators list"
          onClick={onOpen}
          size="md"
          icon={<ShareIcon boxSize={4} />}
        />
      ) : (
        <Button
          leftIcon={<ShareIcon boxSize={4} />}
          variant="primary"
          aria-label="Share creators list"
          onClick={onOpen}
          size="md"
        >
          Share
        </Button>
      )}

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalHeader>Select an option to create a link</ModalHeader>
        <ModalBody>
          <LinkViews />
          <SwitchAudienceFilters />
          <Downloads />
        </ModalBody>
      </Modal>
    </>
  );
};
